import { useContext, useState, useEffect } from 'react';
import { Flex } from 'reflexbox';
import { useHistory } from 'react-router';
import { AssetStatus } from '~/components/AssetStatus';
import {
  Button,
} from '~/components';
import {
  Title, InfoItemShort, StyledLink,
} from './styles';
import {
  BatteryIcon, EletricNetworkIcon, InfoIcon, NobreakOffIcon,
} from 'icons';
import { useTranslation } from 'react-i18next';
import { getUserProfile } from 'helpers/userProfile';
import { colors } from '~/styles/colors';
import { RenderImagesDmtUtility } from '../../DMTs/DmtInfo';
import ReactTooltip from 'react-tooltip';
import MenuContext from '~/contexts/menuContext';
import { apiCall } from '~/providers';
import { toast } from 'react-toastify';
import { verifyInfoAdditionalParameters } from '~/helpers/additionalParameters';
import { formatNumberWithFractionDigits } from '~/helpers/thousandFormatNumber';

export const UtilityTypesInfo = ({ util, screen, type }): JSX.Element => {
  const { t } = useTranslation();
  const history = useHistory();
  const [profile] = useState(getUserProfile);
  const [additionalParameters, setAdditionalParameters] = useState<{ COLUMN_NAME: string; COLUMN_VALUE: string; }[]>([]);
  const nobreakStatus = {
    'Rede Elétrica': {
      icon: <EletricNetworkIcon />,
      label: t('redeEletrica'),
    },
    Bateria: {
      icon: <BatteryIcon width="30" height="18" />,
      label: t('bateria'),
    },
    Desligado: {
      icon: <NobreakOffIcon color="#CFCFCF" />,
      label: t('desligadoMin'),
    },
    Indisponível: {
      icon: <InfoIcon />,
      label: t('semInformacao'),
    },
  };
  const { menuToogle } = useContext(MenuContext);// true = open, false = not Open
  const sizeColumn = menuToogle ? '160px' : '240px';
  const columnItemWidth = screen === 'utilityInfo' ? 'auto' : sizeColumn;
  const deviceLabel = `${util.UTILITY_CODE || '-'} / ${util.DAT_CODE || '-'}`;
  const noOpStatus = !util.STATUS || util.STATUS === 'Indisponível';

  async function getNobreakAdditionalParameters() {
    try {
      setAdditionalParameters([]);
      const parameters = await apiCall('/dmt/get-nobreak-additional-parameters', { NOBREAK_ID: screen === 'dmtInfo' ? Number(util.UTILITY_ID) : Number(util.ID) });
      setAdditionalParameters(parameters);
    } catch (err) {
      console.log(err);
      toast.error(t('houveErro'));
    }
  }
  useEffect(() => {
    getNobreakAdditionalParameters();
  }, [util]);
  const isDMT2 = util.UTILITY_CODE?.startsWith('DMT2') || util.DMT_CODE?.startsWith('DMT2');
  const isElevatorOrEscalator = util.APPLICATION === 'Escalator' || util.APPLICATION === 'Elevator';
  const deviceCode = util.UTILITY_CODE || util.DMT_CODE;
  const isNobreak = util.APPLICATION === 'Nobreak';
  const port = util.PORT ? isElevatorOrEscalator ? `P${util.PORT - 1}` : `F${util.PORT}` : '-';
  return (
    <Flex flexDirection="row" width="100%" marginTop="10px" flexWrap="wrap" justifyContent="space-between" fontSize="13px" padding="20px">
      <Flex width="100%" flexDirection="column" flex="wrap">
        <Flex style={{ width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
          <Flex flexDirection="column">
            <span style={{ fontSize: '12px', fontWeight: 700, lineHeight: '14px' }}>{t('utilitario')}</span>
            <span style={{ fontSize: '15px', fontWeight: 700 }}>{util.NAME}</span>
            <span style={{ fontSize: '10.7px', fontWeight: 500, color: colors.Grey300 }}>
              {(deviceCode)
              && (
                <StyledLink to={`/analise/dispositivo/${deviceCode}/informacoes`}>
                  {deviceLabel}
                </StyledLink>
              )}
              {(!util.UTILITY_CODE && !util.DMT_CODE)
              && (
                <>
                  {deviceLabel}
                </>
              )}
            </span>
          </Flex>
          {(deviceCode) && (
            <AssetStatus
              key={deviceCode}
              DUT_ID={null}
              DEV_AUT={deviceCode}
              DEV_ID={deviceCode}
              isAutomation
              withoutMarginTop
            />
          )}
        </Flex>

        <div style={{ border: '1px solid #DEDEDE', marginTop: '20px' }} />

        <Flex justifyContent="space-between" flexWrap="wrap" width="100%">
          <Flex flexDirection="row" width="50%" flexWrap="wrap" mb="20px" mt="20px">
            <Flex flexWrap="wrap" width="100%" flexDirection="column">
              <Flex flexDirection="row" flexWrap="wrap" justifyContent="space-between" width="100%" alignItems="flex-start">
                <Flex flexDirection="column">
                  <Title>{t('informacoes')}</Title>
                  <InfoItemShort style={{ width: columnItemWidth }}>
                    <b>{t('fabricante')}</b>
                    <br />
                    {util.MANUFACTURER || '-'}
                  </InfoItemShort>

                  <InfoItemShort style={{ width: columnItemWidth }}>
                    <b>{t('modelo')}</b>
                    <br />
                    {util.MODEL_INFO?.MODEL_NAME || '-'}
                  </InfoItemShort>
                </Flex>
                <Flex flexDirection="column">
                  {isNobreak ? (
                    <>
                      <Title>{t('tempoReal')}</Title>
                      <InfoItemShort>
                        <b>{t('statusDeOperacao')}</b>
                        <br />

                        {noOpStatus
                        && (
                          <Flex data-tip data-for="noInfo" flexDirection="row" alignItems="center" justifyContent="flex-start">
                            <InfoIcon />
                            <span style={{ marginLeft: 6 }}>{t('semInformacao')}</span>
                          </Flex>
                        )}

                        {!noOpStatus
                        && (
                        <Flex
                          justifyContent="center"
                          style={{
                            border: '1px solid #EDEDED', borderRadius: '10px', width: '130px', height: '60px', marginTop: '10px', padding: 20,
                          }}
                          alignItems="center"
                        >
                          {(nobreakStatus[util.STATUS]?.icon)}
                          <span style={{ width: '70px', marginLeft: '10px', fontSize: 13 }}>{(nobreakStatus[util.STATUS]?.label)}</span>
                        </Flex>
                        )}
                      </InfoItemShort>
                      {noOpStatus
                      && (
                      <ReactTooltip
                        id="noInfo"
                        place="top"
                        border
                        textColor="#000000"
                        backgroundColor="rgba(255, 255, 255, 0.97)"
                        borderColor="#202370"
                      >
                        <div style={{ width: '200px' }}>
                          <span>{t('semInfoNobreakDmt')}</span>
                        </div>
                      </ReactTooltip>
                      )}
                    </>
                  ) : (
                    <>
                      <Title style={{ marginTop: 10 }}>{t('tempoReal')}</Title>
                      <InfoItemShort>
                        <b>{t('statusDeOperacao')}</b>
                        <br />
                        <p>{util.STATUS || t('semInformacao')}</p>
                      </InfoItemShort>
                    </>
                  )}
                  <Title style={{ marginTop: 10 }}>{t('associacao')}</Title>
                  <InfoItemShort>
                    <b>{isDMT2 ? t('feedbackPortasAssociadas') : t('feedbackDoDmt')}</b>
                    <br />
                    {port}
                    {util.PORT2nd && ` e F${util.PORT2nd}`}
                  </InfoItemShort>
                  {
                    isElevatorOrEscalator && (
                    <InfoItemShort>
                      <b>{t('sensorCorrente')}</b>
                      <br />
                      {util.SENSOR ? util.SENSOR : '-'}
                    </InfoItemShort>
                    )
                  }
                </Flex>
              </Flex>
              {profile.manageAllClients && (
                <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <Button
                    style={{
                      maxWidth: '100px', marginTop: '15px',
                    }}
                    onClick={() => history.push(`/analise/utilitario/${type === 'illumination' ? 'iluminacao' : type.replace(' ', '')}/${util.UTILITY_ID}/editar`, { from: screen })}
                    variant="primary"
                  >
                    {`${t('editar')}`}
                  </Button>
                </div>
              )}
              <Flex flexDirection="row" flexWrap="wrap" justifyContent="flex-start" width="100%" alignItems="flex-start">
                <Flex flexDirection="column">
                  {(additionalParameters.length > 0 || util.MODEL_INFO?.INFO.length > 0) && verifyInfoAdditionalParameters(additionalParameters, false, (util.MODEL_INFO?.INFO || []))}
                </Flex>
              </Flex>
            </Flex>
          </Flex>
          <RenderImagesDmtUtility utilityId={util.UTILITY_ID} utilSelected devCode={util.UTILITY_CODE} deviceId={util.UTILITY_DEVICE_ID} />
        </Flex>
      </Flex>
    </Flex>
  );
};
